import * as React from "react";
import { inject, observer } from "mobx-react";
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';
import { withRouter, Link } from "react-router-dom";

@inject("store")
@observer
export default class TickerBar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const navigation = this.props.store.navigation;
        return (
            <div className="ticker-bar">
                <CarouselProvider
                    naturalSlideWidth={100}
                    naturalSlideHeight={125}
                    totalSlides={navigation.ticker.Ticks.length}
                    isPlaying={navigation.ticker.Ticks.length > 1}
                    interval={5000}
                    orientation="vertical"
                    touchEnabled={false}
                    dragEnabled={false}
                    >
                    <Slider>
                        {navigation.ticker.Ticks.map((tick, i) => (
                            <Slide index={i} key={"tickerbaritem-" + i}>{tick.Text}</Slide>
                        ))}
                    </Slider>
                </CarouselProvider>
            </div>
        );
    }
}